import { createContext, useContext } from "react";
import { toast } from "react-toastify";

import { appSettings } from "../config/appConfig";
import { logOutPage } from "../components/utils/logOut.js";

const BusinessContext = createContext();

export const BusinessContextProvider = ({ children }) => {
  const baseUrl = appSettings.serverBaseUrl;

  const getBusinessCards = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/get-all-business-cards`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const resp = await response.json();
      if ("isValidToken" in resp && !resp?.isValidToken) {
        logOutPage();
      }
      return resp;
    } catch (err) {
      toast.error("Failed to get WA flows data");
      return [];
    }
  };

  const addCompRepresentative = async (phoneNumber, countryCode, name) => {
    try {
      const response = await fetch(`${baseUrl}/api/add-comp-rep`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phoneNumber,
          countryCode,
          name,
        }),
      });

      const resp = await response.json();
      if ("isValidToken" in resp && !resp?.isValidToken) {
        logOutPage();
      } else {
        toast.success(resp.message);
      }
      console.log("Add resp", resp);
      return resp;
    } catch (err) {
      toast.error("Failed to add company representative");
      return {};
    }
  };
  const RemoveCompRepresentative = async (executiveId) => {
    try {
      const response = await fetch(`${baseUrl}/api/remove-comp-rep`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          executiveId,
        }),
      });

      const resp = await response.json();
      if ("isValidToken" in resp && !resp?.isValidToken) {
        logOutPage();
      } else {
        toast.success(resp.message);
      }
      console.log("Remove resp", resp);
      return resp;
    } catch (err) {
      toast.error("Failed to remove company representative");
      return {};
    }
  };

  const getCompanyRepresentatives = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/get-comp-reps`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const resp = await response.json();
      if ("isValidToken" in resp && !resp?.isValidToken) {
        logOutPage();
      }
      return resp;
    } catch (err) {
      toast.error("Failed to get company representatives");
      return [];
    }
  };

  return (
    <BusinessContext.Provider
      value={{
        getBusinessCards,
        addCompRepresentative,
        RemoveCompRepresentative,
        getCompanyRepresentatives,
      }}
    >
      {children}
    </BusinessContext.Provider>
  );
};

export const useBusinessContext = () => useContext(BusinessContext);
